import { Component, Inject } from '@angular/core';
import { Sensor } from '../../../../model/sensor';
import { Subject, takeUntil, forkJoin, from, Observable } from 'rxjs';
import { MatCheckboxChange } from '@angular/material/checkbox';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { AttachmentQualificatesService } from '../../../../services/attachmentQualificates.service';
import { NgxImageCompressService } from 'ngx-image-compress';
import { SpinnerService } from '../../../../services/spinner.service';
import { PhotoUtils } from '../../../../utils/photoUtils';

export interface DialogDataMassiveUpload {
  sensors: Sensor[];
  type: string;
}

@Component({
  selector: 'app-execution-q-edit-essay-massive-upload',
  templateUrl: './execution-q-edit-essay-massive-upload.component.html',
  styleUrl: './execution-q-edit-essay-massive-upload.component.scss',
  standalone: false,
})
export class ExecutionQEditEssayMassiveUploadComponent {

  checked = new Map<string, boolean>();

  private destroy$ = new Subject<void>();

  constructor(
    public dialogRef: MatDialogRef<ExecutionQEditEssayMassiveUploadComponent>,
    @Inject(MAT_DIALOG_DATA) public data: DialogDataMassiveUpload,
    private attachmentQualificatesService: AttachmentQualificatesService,
    private imageCompress: NgxImageCompressService,
    private spinnerService: SpinnerService) { }

  ngOnDestroy(): void {
    this.destroy$.next();
    this.destroy$.complete();
  }

  isSelected(item: Sensor): boolean {
    if (item == null) {
      return false;
    }

    return this.checked.get(`${item.id}`);
  }

  isAllSelected(): boolean {
    return this.data.sensors.every(item => this.isSelected(item));
  }

  onCheckAllItems(event: MatCheckboxChange): void {
    this.data.sensors.forEach(elem => {
      this.checked.set(`${elem.id}`, event.checked);
    });
  }

  onSensorCheck(event: MatCheckboxChange): void {
    this.checked.set(`${event.source.value}`, event.checked);
  }

  disableUploadButton(): boolean {
    const checks = [];

    this.checked.forEach((value, key) => {
      if (value) {
        checks.push(key);
      }
    });

    return checks.length === 0;
  }

  accept(): string {
    let res = '*';

    const type = this.data.type;

    if (type === 'photo') {
      res = 'image/*';
    } else if (type === 'excel') {
      res = '.xlsx, .xls, .csv, .pdf';
    }

    return res;
  }

  uploadSensor(id: string, file: File): Observable<number> {
  return new Observable<number>(observer => {
    PhotoUtils.fixImage(file, this.imageCompress, (res: File) => {
      this.attachmentQualificatesService.uploadPhotoToSensor(+id, res)
        .pipe(takeUntil(this.destroy$))
        .subscribe({
          next: (idPhoto) => {
            console.log(idPhoto);
            observer.next(idPhoto);
            observer.complete();
          },
          error: err => observer.error(err)
        });
    });
  });
}

  onNoClick(): void {
    this.dialogRef.close();
  }

  uploadMassive(event: Event): void {
  this.spinnerService.show();

  const file = (event.target as HTMLInputElement).files?.[0];
  if (!file) {
    this.spinnerService.hide();
    return;
  }

  const selectedIds = Array.from(this.checked.entries())
    .filter(([_, isChecked]) => isChecked)
    .map(([id, _]) => id);

  if (selectedIds.length === 0) {
    this.spinnerService.hide();
    return;
  }

  const type = this.data.type;
  const tasks: Observable<number>[] = [];

  for (const id of selectedIds) {
    if (type === 'photo') {
      tasks.push(this.uploadSensor(id, file));
    } else if (type === 'primary') {
      tasks.push(this.attachmentQualificatesService.uploadPrimaryFileToSensor(+id, file));
    }
  }

  forkJoin(tasks).pipe(takeUntil(this.destroy$)).subscribe({
    next: (results: number[]) => {
      results.forEach((res, index) => {
        const id = selectedIds[index];
        const sensor = this.data.sensors.find(s => s.id === +id);
        if (!sensor) return;

        if (type === 'photo') {
          sensor.idPhoto = res;
        } else if (type === 'primary') {
          sensor.idPrimaryDataFile = res;
        } else if (type === 'excel') {
          sensor.idExcel = res;
        }
      });

      this.dialogRef.close(this.data.sensors);
    },
    error: (err) => {
      console.error('Error al subir archivos:', err);
    },
    complete: () => {
      this.spinnerService.hide();
    }
  });
}



}
